import { User } from '../models/user';

export class AddUsers {
    static readonly type = '[User] AddUsers';

    constructor(public payload: User[]) {}
}
